/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import { produce } from 'immer';

import {
  INIT_TVSCREEN,
  SET_LIFECYCLE_DATA,
  SET_LIFECYCLE_STATE,
  SET_LIFECYCLE_DRAW,
  JACKPOT_HIT,
  JACKPOT_UPDATE,
  ADD_BET_IN_BETSLIP,
  STATISTICS,
  SET_TIPS_TO_CASHIER
} from "./actions";

// The initial state of the App
export const initialState = {
  appSettings: {
    // inittvscreen data
    language: "en"
  },
  statistics: {
    // statistics includes previous rounds result and data for statistics block
  },

  lifecycleData: {
    // lifecycle consists only data related to winning plan(update every new round???) now here is present only WINNINGPLAN data
    LifeCycleStatus: "",
    Round: 0,
    WinningPlan: [
      {
        BetType: 0,
        Specifier: 0,
        Value: 0.0
      }
    ],

    Countdown: 0,
    minStake: -1,
    maxStake: -1,
    minSystemStake: -1
  },
  currentLifecycleState: null,
  Round: 0,

  jackpotHitData: {},

  jackPotStatus: {
    Jackpot: 0
  },

  eventHistoryLoading: false,
  showModal: null,
  eventsOdds: [], // events with its odds
  slideAsideBlockId: null,
  eventHistory: [],
  betHistory: [],
  betsFromBackend: {},
  betsObject: {} // array of bets(this item use for betslip render in basket) key - bet type, value - object with bet data
};

const appReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      /**
       * INIT_TVSCREEN
       * */
      case INIT_TVSCREEN:
        draft.appSettings = { ...action.payload };
        break;

      /**
       * SET_LIFECYCLE_DATA
       * */
      case SET_LIFECYCLE_DATA:
        draft.lifecycleData = { ...action.payload };
        draft.Round = action.payload.Round;
        break;

      /**
       * SET_LIFECYCLE_STATE
       * */
      case SET_LIFECYCLE_STATE:
        draft.currentLifecycleState = '';
        draft.currentLifecycleState = action.payload;
        break;

      /**
       * JACKPOT_HIT
       * */
      case JACKPOT_HIT:
        const jackpotHittedData = { ...action.payload, isHitted: true };
        draft.jackpotHit = { ...jackpotHittedData };
        break;

      /**
       * JACKPOT_UPDATE
       * */
      case JACKPOT_UPDATE:
        draft.jackPotStatus = { ...action.payload };
        break;

      /**
       * set new bet in BETSLIP
       * */
      case ADD_BET_IN_BETSLIP:
        draft.betsObject = { ...action.payload };
        break;

      /**
       * save relevant STATISTICS after each DRAW
       * */
      case STATISTICS:
        draft.statistics = { ...action.payload };
        break;

      /**
       * SET_LIFECYCLE_DRAW
       */
      case SET_LIFECYCLE_DRAW:
        draft.Round = action.payload.Round;
        break;

      /**
       * set modal window name and show it
       * */
      case "OPEN_MODAL_WINDOW":
        draft.showModal = action.payload;
        break;

      /**
       * set data for current bet basket
       * */
      case "SET_BET_HISTORY":
        draft.betHistory = [...action.payload];
        break;

      /**
       * get jackpots data
       * **/
      case "JACKPOT_DATA_RECIEVED":
        draft.jackPot = action.payload.jackpotBalance;
        draft.superJackPot = action.payload.superJackpotBalance;
        break;

      /**
       * set ID of aside slide block which are showing
       * */
      case "SLIDE_ASIDE_BLOCK":
        const newSlideAsideBlockId =
          action.payload === state.slideAsideBlockId ? null : action.payload;
        draft.slideAsideBlockId = newSlideAsideBlockId;
        break;

      case SET_TIPS_TO_CASHIER:
          draft.betsFromBackend = { ...action.payload };
        break;

      default:
        return state;
    }
  });

export default appReducer;
